import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
// import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// import { MemberQuery } from '../../../account/member/member.query';
// import { LoggingService } from '../core/logging.service';
// import { AccountStatus } from '../../../account/member/models/account-status.model';

/**
 * Commenting this as this is causing a lot of issues, interceptor runs first before the guard gets triggered,
 * and the guard is the one that should be handling the redirect. Having this with the guard would result to an infinite loop of
 * redirects. Passing the logic to the error handler instead
 */
@Injectable()
export class FirstTimeRegistrationInterceptor implements HttpInterceptor {
  // constructor(
  //   private memberQuery: MemberQuery,
  //   private logService: LoggingService,
  //   private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((response: HttpErrorResponse) => {
          // if (response.status === 403) {
            // let userContext = this.memberQuery.getUserContext();
            // if (userContext && userContext.status === AccountStatus.FirstTimeUser) {
              // this.logService.info('403 Forbidden response received, user is first time user.');

              // this.setRedirectUrlAfterRegistration(this.router.url);

              // this.logService.info('Redirecting to first time user registration...');
              // this.router.navigate(['/register/firsttime']);
            // }
          // }
          return throwError(() => response);
      }
    ));
  }

  // private setRedirectUrlAfterRegistration(url: string): void {
  //   const queryStringParameter: string = 'returnUrl=';
  //   let startIndex: number = url.toUpperCase().indexOf(queryStringParameter.toUpperCase());

  //   if (!isNaN(startIndex)) {
  //     startIndex += queryStringParameter.length;
  //     let endIndex = url.indexOf('&');
  //     let substrLength: number | undefined =  endIndex ? endIndex - startIndex : undefined;

  //     url = url.substr(startIndex, substrLength);
  //     url = decodeURIComponent(url);
  //   }

  //   this.logService.debug('Setting redirectToUrlAfterRegistration session key to:', url);
  //   sessionStorage.setItem('redirectToUrlAfterRegistration', url);
  // }
}



